<template>
  <div class="column">
    <loading-state
      v-if="loading"
      :message="$t('DASHBOARD_APPS.LOADING_MESSAGE')"
    />
    <dashboard-app-frame
      v-else-if="dashboardAPP"   
      :is-visible="true"
      :dashboard-app="dashboardAPP"    
    />
    <div v-else>
      <empty-state :title="$t('DASHBOARD_APPS.NO_DATA')" />
    </div>
  </div> 
</template>
<script>

import alertMixin from 'shared/mixins/alertMixin';
import LoadingState from 'dashboard/components/widgets/LoadingState';
import DashboardAppsAPI from 'dashboard/api/dashboardApps';
import EmptyState from 'dashboard/components/widgets/EmptyState';
import DashboardAppFrame from 'dashboard/components/widgets/DashboardApp/Frame.vue';

export default {
  components: {
    LoadingState,
    EmptyState,
    DashboardAppFrame
  },
  mixins: [alertMixin],
  props: {
    slug: String
  },
  data() {
    return {
      loading: true,
      dashboardAPP: null
    };
  },  
  watch: {
    slug: {
      async handler() {
        this.render();
      },
      immediate: true
    }
  },
  methods: {
    async render(){
      this.loading = true;
      this.dashboardAPP = null;
      try{
        const resp = await DashboardAppsAPI.show(this.slug);
        if(resp?.data?.content && resp.data.content.url && resp.data.content.url.trim() != ""){
          this.dashboardAPP = { ...resp.data, content: [resp.data.content] };
        }
        this.loading = false;
      }catch(error){
        this.loading = false;
        this.showAlert(this.$t('DASHBOARD_APPS.ERROR_FETCH'));
      } 

    }
  }
};
</script>